import { render } from "./ActionSelector.vue?vue&type=template&id=4a59cb77"
import script from "./ActionSelector.vue?vue&type=script&lang=js"
export * from "./ActionSelector.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ActionSelector.vue"]])

export default __exports__